import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [wishlist, setWishlist] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setWishlist(data.wishlist || []);
    } catch {
      setUser(false);
      setWishlist([]);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    setWishlist(data.wishlist || []);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    setWishlist(data.wishlist || []);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
    setWishlist([]);
  };

  const toggleWishlist = async (productId) => {
    const { data } = await api.post(`/wishlist/${productId}`);
    setWishlist(data.wishlist);
    return data.added;
  };

  return (
    <AuthContext.Provider
      value={{ user, wishlist, login, register, logout, toggleWishlist, refresh }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
